import { render, staticRenderFns } from "./PrestationsMainsPieds.vue?vue&type=template&id=60fa12f2&"
import script from "./PrestationsMainsPieds.vue?vue&type=script&lang=js&"
export * from "./PrestationsMainsPieds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports